import { render } from "./SubscriptionDetail.vue?vue&type=template&id=4c8db19a&scoped=true&ts=true"
import script from "./SubscriptionDetail.vue?vue&type=script&lang=ts"
export * from "./SubscriptionDetail.vue?vue&type=script&lang=ts"

import "./SubscriptionDetail.vue?vue&type=style&index=0&id=4c8db19a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c8db19a"]])

export default __exports__